import userModel from "../model/userModel"
import api from "../network/netApi"
import commonService from "./commonService"
import url from "../config/url"

let userService = {
    //返回userModel对象
    getModel() {
        return userModel;
    },
    getNetApi(){
        return api;
    },
    //登录
    login(param) {
        return new Promise(function (resolve, reject) {
            userModel.clear();
            api.loginToken(param, ret => {
                if (ret.isSuccess == "1") {
                    ret.result.permissions = ret.permissions;
                    userModel.init(ret.result);
                    let authorityList = commonService.checkIsShowTab(ret.permissions);
                    userModel.setData("userRoles", ret.result.userroles?ret.result.userroles.split(','):"");
                    userModel.setData("authorityList", authorityList);
                    resolve(ret.result);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    //短信登录
    smsLogin(param){
        return new Promise(function(resolve, reject) {
            userModel.clear();
            api.smsLogin(param, ret => {
                if (ret.isSuccess=="1") {
                    ret.result.permissions=ret.permissions;
                    userModel.init(ret.result);
                    let authorityList=commonService.checkIsShowTab(ret.permissions);
                    userModel.setData("authorityList",authorityList);
                    userModel.setData("userRoles", ret.result.userroles?ret.result.userroles.split(','):"");
                    resolve(ret.result);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    rigister(param){
        return new Promise(function(resolve, reject) {
            userModel.clear();
            api.getregister(param, ret => {
                if (ret.isSuccess == "1") {
                    ret.result.permissions = ret.permissions;
                    userModel.init(ret.result);
                    let authorityList = commonService.checkIsShowTab(ret.permissions);
                    userModel.setData("authorityList", authorityList);
                    userModel.setData("userRoles", ret.result.userroles?ret.result.userroles.split(','):"");
                    resolve(ret.result);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    getAuth(param) {
        return new Promise(function (resolve, reject) {
            api.getAuth(param, ret => {
                if (ret.result) {
                    resolve(ret.result);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    loginAuth(param){
        return new Promise(function(resolve, reject) {
            api.loginAuth(param, ret => {
                if (ret.isSuccess) {
                    resolve(ret.result);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    pointInfo(){
        return new Promise(function(resolve, reject) {
            let param={
                perssionId:10304,
                user_id:userModel.getModel().userid,
            };
            api.showSignInStatus(param, ret => {
                if (ret) {
                    if (typeof ret.errorMsg == "undefined") {
                        resolve(ret);
                    } else {
                        reject(ret.errorMsg)
                    }
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    pointList(param) {
        return new Promise(function (resolve, reject) {
            api.getPointList(param, ret => {
                if (ret) {
                    if (ret.items instanceof Array || ret.items == '') {
                        resolve(ret.items);
                    } else {
                        resolve([ret.items]);
                    }
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    userSignIn(param) {
        return new Promise(function (resolve, reject) {
            api.userSignIn(param, ret => {
                if (ret.result) {
                    resolve(ret.result);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    changePwd(param) {
        return new Promise(function (resolve, reject) {
            api.changePwd(param, ret => {
                if (typeof ret.isSuccess == "undefined") {
                    resolve(ret);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    getMobileBindAuth(param) {
        return new Promise(function (resolve, reject) {
            api.getMobileBindAuth(param, ret => {
                if (ret.result) {
                    resolve(ret.result);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    validMobileOld(param) {
        return new Promise(function (resolve, reject) {
            api.validMobileOld(param, ret => {
                if (ret.isSuccess == "1") {
                    resolve(ret);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    validMobileNew(param) {
        return new Promise(function (resolve, reject) {
            api.validMobileNew(param, ret => {
                if (ret.isSuccess == "1") {
                    resolve(ret);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    getPromoteCode(userId) {
        return new Promise(function (resolve, reject) {
            let param={
                perssionId:10605,
                user_id:userId||userModel.getModel().userid
            };
            api.getPromoteCode(param, ret => {
                if (ret.isSuccess) {
                    resolve(ret.result.promoteCode);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    addAgencyCustomer(param) {
        return new Promise(function (resolve, reject) {
            param.perssionId=10602;
            param.agent_user_id=userModel.getModel().userid;
            api.addAgencyCustomer(param, ret => {
                if (ret.isSuccess) {
                    resolve(ret);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    customerPaginal(param) {
        return new Promise(function (resolve, reject) {
            param.perssionId=10601;
            param.agent_user_id=userModel.getModel().userid;
            api.customerPaginal(param, ret => {
                if (ret) {
                    if (ret.items instanceof Array || ret.items == '') {
                        resolve(ret.items);
                    } else {
                        resolve([ret.items]);
                    }
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    agencyBusinessOpportunityPaginal(param) {
        return new Promise(function (resolve, reject) {
            param.perssionId=10604;
            param.agency_user_id=userModel.getModel().userid;
            param.business_source_type="F_AGENCY_B";
            api.agencyBusinessOpportunityPaginal(param, ret => {
                if (ret) {
                    if (ret.items instanceof Array || ret.items == '') {
                        resolve(ret.items);
                    } else {
                        resolve([ret.items]);
                    }
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    getProductInfoMap() {
        return new Promise(function (resolve, reject) {
            let param={
                user_id:userModel.getModel().userid,
            }
            api.getProductInfoMap(param, rec => {
                if (rec) {
                    resolve(rec);
                } else {
                    reject(rec.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    applyInnerUser(param) {
        return new Promise(function (resolve, reject) {
            api.applyInnerUser(param, ret => {
                if (ret.isSuccess) {
                    resolve(ret);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    getApplyList(param) {
        return new Promise(function (resolve, reject) {
            param.partnerUserId=userModel.getModel().userid;
            param.perssionId=10702;
            api.getApplyList(param, ret => {
                if (ret) {
                    if (ret.items instanceof Array || ret.items == '') {
                        resolve(ret.items);
                    } else {
                        resolve([ret.items]);
                    }
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    getSignApplyList(param) {
        return new Promise(function (resolve, reject) {
            let paramAdd= {
                perssionId: 10402,
                sign_user_id: userModel.getModel().userid,
            }
            param=Object.assign(param, paramAdd);
            api.getSignApplyList(param, ret => {
                if (ret) {
                    if (ret.items instanceof Array || ret.items == '') {
                        resolve(ret.items);
                    } else {
                        resolve([ret.items]);
                    }
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    getProductTree(param) {
        return new Promise(function (resolve, reject) {
            api.getProductTree(param, ret => {

                if (ret) {
                    if (ret instanceof Array || ret == '') {
                        resolve(ret);
                    } else {
                        resolve([ret]);
                    }
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    getConfirm(param) {
        return new Promise(function (resolve, reject) {
            api.getConfirm(param, ret => {
                if (ret.isSuccess) {
                    resolve(ret);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    //确认合同 权限号:104021 isConfirmPass:true(确认),false(拒绝) id:合同Id,sign_user_id:登录账号Id
    confirmSignApplyInfo(param){
        return new Promise(function(resolve, reject) {
            param.sign_user_id=userModel.getModel().userid;
            param.perssionId=104021;
            api.confirmSignApplyInfo(param, ret => {
                if (ret) {
                    resolve(ret.result);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    //合同详情 权限号:104031 id:合同Id
    getSignApplyInfoById(param){
        return new Promise(function(resolve, reject) {
            let paramAdd= {
                perssionId: 104031,
                user_id: userModel.getModel().userid,
            }
            param=Object.assign(param, paramAdd);
            api.getSignApplyInfoById(param, ret => {
                if(ret.id!=null){
                    resolve(ret);
                }else{
                    if(!ret.isSuccess){
                        reject(ret.errorMsg);
                    }else{
                        reject("详情读取失败");
                    }
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    getFullPath(param_){
        return new Promise(function(resolve, reject) {
            api.getContractFullPath(param_, rec => {
                if(rec.isSuccess){
                    resolve({pdfurl:url.upload+rec.result.contractFileUrl,pdfname:rec.result.contractName});
                }else{
                    reject(new Error(rec.errorMsg)) 
                }
            }, error => {
                reject(new Error("连接远程服务器失败")) 
            })
        });
    },
    getContractFullPath(param){
        let that=this;
        return new Promise(function(resolve, reject) {
            param.perssionId=104031;
            that.getContractListBySignId(param).then(
                ret=>{
                    let result=[];
                    if(ret instanceof Array && ret!=""){
                        ret.forEach(item => {
                            let paramAdd={
                                contract_no:item.contractNo,
                                user_id:userModel.getModel().userid,
                            }
                            that.getFullPath(paramAdd).then(
                                ret1=>{
                                    result.push(ret1) 
                                }
                            ).catch(e=>{
                                reject(e)
                            })
                        });
                    }else{
                        let paramAdd={
                            contract_no:ret.contractNo,
                            user_id:userModel.getModel().userid,
                        }
                        that.getFullPath(paramAdd).then(
                            ret1=>{
                                result.push(ret1) 
                            }
                        ).catch(e=>{
                            reject(e)
                        })
                    }
                    resolve(result);
                },error=>{
                    reject(error);
                }
            )
            
        });
    },
    getContractListBySignId(param){
        return new Promise(function(resolve, reject) {
            api.getContractListBySignId(param, ret => {
                if(ret instanceof Array || ret!=""){
                    resolve(ret);
                }else{
                    if(ret.id!=null){
                        resolve(ret);
                    }else if(!ret.isSuccess){
                        reject(ret.errorMsg);
                    }else{
                        reject("详情读取失败!");
                    }
                }
                
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    //合同详情 不需要权限码 applyId:申请商机Id
    getPartnerDetail(param){
        return new Promise(function(resolve, reject) {
            api.getPartnerDetail(param, ret => {
                if (ret.errorCode=="0000") {
                    resolve(ret);
                } else {
                    reject(ret.errorMsg)
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    //客户信息 权限号:1060103(编辑客户)或1060102(查看客户) id:合同Id
    getCustomerUserInfo(param){
        return new Promise(function(resolve, reject) {
            param.perssionId=1060102;
            param.agent_user_id=userModel.getModel().userid;
            api.getCustomerUserInfo(param, ret => {
                if (ret) {
                    resolve(ret);
                } else {
                    if(typeof ret.isSuccess!="undefined"){
                        reject(ret.errorMsg);
                    }else{
                        reject("操作失败");   
                    }
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    //客户信息 权限号:1060103 agent_user_id:登录Id,customer_user_id:客户Id, part_full_name:公司名称,
    //cell_phone:手机号,orgContPhone:公司电话,orgAddress:公司地址,busiLiceNumber:营业执照代码
    editAgencyCustomer(param){
        return new Promise(function(resolve, reject) {
            param.perssionId=1060103;
            param.agent_user_id=userModel.getModel().userid;
            api.editAgencyCustomer(param, ret => {
                if (ret.isSuccess) {
                    resolve(ret);
                } else {
                    reject(ret.errorMsg);
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    //签到验证码发送、
    getSignInAuth(param){
        return new Promise(function(resolve, reject) {
            api.getSignInAuth(param, ret => {
                if (ret.isSuccess) {
                    resolve(ret);
                } else {
                    reject(ret.errorMsg);
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    //签到
    signIn(param){
        return new Promise(function(resolve, reject) {
            api.signIn(param, ret => {
                if (ret.isSuccess=="1") {
                    userModel.clear();
                    ret.result.permissions = ret.permissions;
                    userModel.init(ret.result);
                    let authorityList = commonService.checkIsShowTab(ret.permissions);
                    userModel.setData("userRoles", ret.result.userroles?ret.result.userroles.split(','):"");
                    userModel.setData("authorityList", authorityList);
                    resolve(ret);
                } else {
                    reject(ret.errorMsg);
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    //打赏
    tippingVia(param){
        return new Promise(function(resolve, reject) {
            param.perssionId=10605;
            param.tipping_from_user_id=userModel.getModel().userid;
            api.tippingVia(param, ret => {
                if (ret.isSuccess) {
                    resolve(ret);
                } else {
                    reject(ret.errorMsg);
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    getNavBar(){
        return new Promise(function(resolve, reject) {
            api.getNavBar({navBarType:"index",navBarSort:"SORT"}, ret => {
                if (ret.result) {
                    resolve(ret.result);
                } else {
                    reject(ret.errorMsg);
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    },
    getticket(param){
        return new Promise(function(resolve, reject) {
            api.getticket(param, ret => {
                if (ret) {
                    resolve(ret);
                } else {
                    reject(ret.errorMsg);
                }
            }, error => {
                reject("微信签名失败");
            })
        });
    },
    activity_temp(param){
        return new Promise(function(resolve, reject) {
            api.activity_temp(param, ret => {
                if (ret.isSuccess=="1") {
                    const start = new Date(ret.bizActivity.activityStartTime);
                    const end=  new Date(ret.bizActivity.activityEndTime);
                    const now=new Date();
                    const time1=now-start;
                    const time2=end-now;
                    if(time1<0){
                        reject("活动还未开始");
                        return;
                    }
                    if(time2<0){
                        reject("活动已经结束");
                    }else
                    resolve(ret);
                } else {
                    reject(ret.errorMsg);
                }
            }, error => {
                reject("连接远程服务器失败");
            })
        });
    }
}
export default userService;


// WEBPACK FOOTER //
// ./src/service/UserService.js